import { marked } from 'marked'
import { serializeParameters } from '@/utils/general'
import textVariablesMixin from '@/mixins/textVariables'

export default {
  mixins: [textVariablesMixin],
  computed: {
    topics () {
      const path = 'FAQ.Topics'

      const topics = this.$t(path)

      if (!Array.isArray(topics)) {
        return []
      }

      return topics.map((topic, i) => {
        if (!topic || !topic?.Title || !topic?.Icon || !topic?.Url || !topic?.Questions || !topic?.Questions.length) {
          return null
        }

        const questions = this.$t(`${path}[${i}].Questions`).map((_, index) => {
          const question = this.$t(`${path}[${i}].Questions[${index}].Question`, { ...this.textVariables })
          const answer = this.$t(`${path}[${i}].Questions[${index}].Answer`, { ...this.textVariables })

          if (question === ' ' || answer === ' ') {
            return null
          }

          return {
            question: marked.parse(question),
            answer: marked.parse(answer),
            path: this.$t(`${path}[${i}].Questions[${index}].Path`)
          }
        }).filter(Boolean)

        return {
          title: this.$t(`${path}[${i}].Title`, { ...this.textVariables }),
          icon: topic.Icon,
          url: topic.Url,
          description: topic.Description,
          questions,
          to: {
            name: 'men-customer-service-topic',
            params: {
              topic: topic.Url.replace('men-customer-service-', '')
            }
          }
        }
      }).filter(Boolean)
    },
    womenTopics () {
      const path = 'FAQ.WomenTopics'

      const topics = this.$t(path)

      if (!Array.isArray(topics)) {
        return []
      }

      return topics.map((topic, i) => {
        if (!topic || !topic?.Title || !topic?.Icon || !topic?.Url || !topic?.Questions || !topic?.Questions.length) {
          return null
        }

        const questions = this.$t(`${path}[${i}].Questions`).map((_, index) => {
          const question = this.$t(`${path}[${i}].Questions[${index}].Question`, { ...this.textVariables })
          const answer = this.$t(`${path}[${i}].Questions[${index}].Answer`, { ...this.textVariables })

          if (question === ' ' || answer === ' ') {
            return null
          }

          return {
            question: marked.parse(question),
            answer: marked.parse(answer),
            path: this.$t(`${path}[${i}].Questions[${index}].Path`)
          }
        }).filter(Boolean)

        return {
          title: this.$t(`${path}[${i}].Title`, { ...this.textVariables }),
          icon: topic.Icon,
          url: topic.Url,
          description: topic.Description,
          questions,
          to: {
            name: 'women-customer-service-topic',
            params: {
              topic: topic.Url.replace('women-customer-service-', '')
            }
          }
        }
      }).filter(Boolean)
    }
  },
  methods: {
    getQuestionByPath (path = '') {
      const question = this.topics.reduce((acc, Topic) => {
        if (acc.title) {
          return acc
        }

        const q = Topic.questions.find(question => question.path === path)

        if (q) {
          acc.title = q.question
          acc.to = Topic.to
          acc.queryParams = serializeParameters({ question: q.path })
        }

        return acc
      }, {
        title: '',
        to: {},
        queryParams: ''
      })

      return question
    },
    getWomenQuestionByPath (path = '') {
      const question = this.womenTopics.reduce((acc, Topic) => {
        if (acc.title) {
          return acc
        }

        const q = Topic.questions.find(question => question.path === path)

        if (q) {
          acc.title = q.question
          acc.to = Topic.to
          acc.queryParams = serializeParameters({ question: q.path })
        }

        return acc
      }, {
        title: '',
        to: {},
        queryParams: ''
      })

      return question
    }
  }
}
